<template>
  <div class="electrode-content">
    <div class="electrode-row">
      <div class="electrode-col electrode-bg1">
        <div class="hand-box">
          <img src="/static/images/body-shou.png"/>
          <div class="feet-desc">
            Hands<br/>
            and feet
          </div>
        </div>
        <div class="foot-box">
          <img src="/static/images/body-jiao.png"/>
        </div>
        <div class="body-box">
          <img src="/static/images/body-jd.png"/>
        </div>
      </div>
      <div class="electrode-col">
        <h3 style="color: #FFFFFF;margin-bottom: 20px;">Direct Segmental Measurements</h3>
        <p>We uses Multiple Frequencies 8-Point Tactile Electrode System,with two electrodes placed on each hand and each foot. During measurement, the electrodes individually detect impedance data from five body segments: the left arm, right arm, torso, left leg and right leg.</p>
        <p>
          Compared to traditional BIA measurements, our use of multiple frequencies of alternating current allows for better penetration of body cells and greater resistance to external electromagnetic interference. This enables us to obtain more accurate measurements of body composition.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ElectrodeMeasurement'
}
</script>

<style scoped>
/* 组件特定样式 */
</style>